/**
 * Centralized storage keys to avoid magic strings
 */
export const STORAGE_KEYS = {
  COGNITO_CONFIG: 'portal_cognito_config',
  USER_DETAILS: 'portal_user_details',
  PORTAL_SELECTION_HIDDEN_UNTIL: 'portal_selection_hidden_until',
  /** Also written by the main currentware.com website — keep the name and JSON shape in sync with it. */
  COOKIE_CONSENT: 'cwcc_consent_v2',
  LEAD_SOURCE: 'lead_source',
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];
